import React, { createContext, useState, useEffect, useContext } from "react";
import { AuthContext } from "./AuthProvider";

export const TemplateContext = createContext();

export const TemplateProvider = ({ children }) => {
    const [userTemplates, setUserTemplates] = useState([]);
    const [systemTemplates, setSystemTemplates] = useState([]);
    const [selected, setSelected] = useState("all");
    const [loading, setLoading] = useState(true); // Default loading state is true

    const { token } = useContext(AuthContext);

    const apiBaseUrl = "https://api.coudy.ai/user";

    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
    };

    const fetchTemplates = async () => {
        try {
            if(!token) return;
            if(userTemplates.length === 0) {
                setLoading(true);
            }
            const [userRes, systemRes] = await Promise.all([
                fetch(`${apiBaseUrl}/templates`, { headers }),
                fetch(`${apiBaseUrl}/templates/system`, { headers }),
            ]);
            if (!userRes.ok || !systemRes.ok) throw new Error("Failed to fetch templates.");
            const userTemplatesS = await userRes.json();
            const systemTemplatesS = await systemRes.json();
            setUserTemplates(userTemplatesS.templates || []);
            setSelected(systemTemplatesS.selected);
            setSystemTemplates(systemTemplatesS.templates || []);
        } catch (error) {
            console.error(`Error fetching templates: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!token) {
            return;
        }
        fetchTemplates();
    }, [token]);

    const mergeTemplates = () => {
        const combinedTemplates = [...userTemplates];
        systemTemplates.forEach((template) => {
            if (!combinedTemplates.some((t) => t.template_id === template.template_id)) {
                combinedTemplates.push(template);
            }
        });
        return combinedTemplates;
    };

    const findTemplateById = (templateId) => {
        const allTemplates = mergeTemplates();
        return allTemplates.find((template) => template.template_id + "" === templateId + "") || null;
    };

    //check which categories does not have any templates: student, freelancer, business, ultimate
    const checkEmptyCategories = () => {
        const allTemplates = mergeTemplates();
        const categories = ['student', 'freelancer', 'business', 'ultimate'];
        const emptyCategories = [];
        categories.forEach(category => {
            if (!allTemplates.some(template => template.category === category)) {
                emptyCategories.push(category);
            }
        });
        return emptyCategories;
    };

    return (
        <TemplateContext.Provider
            value={{
                templates: mergeTemplates(),
                loading,
                fetchTemplates,
                selected,
                findTemplateById,
                checkEmptyCategories: checkEmptyCategories(),
            }}
        >
            {children}
        </TemplateContext.Provider>
    );
};

